export const FACTORS = ["gezin", "kind", "omgeving"] as const;
export type Factor = (typeof FACTORS)[number];

export const TOP_SECTIONS = ["hypotheses", "ideeen", "vragen"] as const;
export type TopSection = (typeof TOP_SECTIONS)[number];

export interface TopSectionItem {
  id: string;
  text: string;
}

export interface TriangleItem {
  id: string;
  text: string;
  factor: Factor;
  x: number;
  y: number;
}

export interface DriehoekData {
  name: string;
  basisgegevens: string;
  topSections: Record<TopSection, TopSectionItem[]>;
  items: TriangleItem[];
}

export const MAX_ITEMS_WARNING = 20;

export const FACTOR_LABELS: Record<Factor, string> = {
  gezin: "Gezinscontext & opvoeding",
  kind: "Ontwikkeling Kind",
  omgeving: "Ervaringen & omgeving",
};

export const SECTION_LABELS: Record<TopSection, string> = {
  hypotheses: "Hypotheses",
  ideeen: "Ideeën",
  vragen: "Vragen",
};
